module.exports = __webpack_public_path__ + "img/icon_sm_ycl.ff999c99.png";